import { render, staticRenderFns } from "./Real.vue?vue&type=template&id=0ab2bde5&scoped=true&"
import script from "./Real.vue?vue&type=script&lang=js&"
export * from "./Real.vue?vue&type=script&lang=js&"
import style0 from "./Real.vue?vue&type=style&index=0&id=0ab2bde5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab2bde5",
  null
  
)

export default component.exports